import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-07a6a738")

_pushScopeId("data-v-07a6a738")
const _hoisted_1 = { class: "grid-container employee-list-container" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "container r-grid" }, [
  /*#__PURE__*/_createVNode("h2", null, "Managed Employees With New Requests")
], -1)
const _hoisted_3 = { class: "employee-name" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "container r-grid" }, [
  /*#__PURE__*/_createVNode("h2", null, "Managed Employees")
], -1)
const _hoisted_5 = { class: "no-pending-requests" }
const _hoisted_6 = { class: "employee-name" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.employeesListData, (employee, index) => {
      return (_openBlock(), _createBlock(_Fragment, { key: index }, [
        (employee.pending_requests > 0)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              class: "employee-link r-grid",
              to: `/manage-employees/${employee.uin}`
            }, {
              default: _withId(() => [
                _createVNode("div", {
                  class: { 'pending-requests': employee.pending_requests > 0 }
                }, _toDisplayString(employee.pending_requests), 3),
                _createVNode("div", _hoisted_3, _toDisplayString(employee.name), 1)
              ]),
              _: 2
            }, 1032, ["to"]))
          : _withDirectives((_openBlock(), _createBlock("p", {
              key: 1,
              class: "message r-grid",
              innerHTML: _ctx.randomizeMessage(_ctx.empty1)
            }, null, 8, ["innerHTML"])), [
              [_vShow, _ctx.noRequests === 0 && index === 0]
            ])
      ], 64))
    }), 128)),
    _hoisted_4,
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.employeesListData, (employee, index) => {
      return (_openBlock(), _createBlock(_Fragment, { key: index }, [
        (employee.pending_requests === 0)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              class: "employee-link r-grid",
              to: `/manage-employees/${employee.uin}`
            }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_5, _toDisplayString(employee.pending_requests), 1),
                _createVNode("div", _hoisted_6, _toDisplayString(employee.name), 1)
              ]),
              _: 2
            }, 1032, ["to"]))
          : _createCommentVNode("", true),
        _withDirectives(_createVNode("p", {
          class: "message r-grid",
          innerHTML: _ctx.randomizeMessage(_ctx.empty2)
        }, null, 8, ["innerHTML"]), [
          [_vShow, _ctx.employeesListData.length === _ctx.noRequests && index === 0]
        ])
      ], 64))
    }), 128))
  ]))
})